import { CONTEXT } from "@/constants";
import Axios from "axios";

export async function sendUserFile({
  bot_id,
  conversation_id,
  file,
  sendMessage,
}) {
  const formData = new FormData();
  formData.set("file", file);

  const baseURL = process.env.VUE_APP_API_SERVER;
  const endpoint =
   localStorage.getItem('context') === CONTEXT.SANDBOX ? 
    `${baseURL}/chat/send-file-draft/${bot_id}/${conversation_id}` :
    `${baseURL}/chat/send-file/${bot_id}/${conversation_id}`;

  const result = await Axios({
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    url: endpoint,
    data: formData,
  });

  const fileData = result.data?.length >= 1 ? result.data[0] : result.data;

  await sendMessage({
    text: "",
    type: fileData?.fileType,
    isFile: true,
    file: fileData?.url,
  });

  return fileData;
}
